<!-- =========================================================================================
  File Name: VerticalNavMenu.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="parentx">
      
    <vs-sidebar
      class="v-nav-menu items-no-padding"
      v-model="isVerticalNavMenuActive"
      ref="verticalNavMenu"
      default-index="-1"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      :parent="parent"
      :hiddenBackground="clickNotClose"
      :reduce="reduce"
      v-hammer:swipe="onMenuSwipe">

      <div @mouseenter="mouseEnter" @mouseleave="mouseLeave">

        <!-- Header -->
        <div class="header-sidebar flex items-end justify-between" slot="header">

          <!-- Logo -->
          <router-link tag="div" class="vx-logo cursor-pointer flex px-5 justify-center items-start w-full" style="" to="">
            <img v-if="$store.state.dash.logoURL"  class="pt_logo" style="max-height: 50px; max-width: 100%;" :src="$store.state.dash.logoURL"/>
            <img v-else  class="w-full py-5" src="@/assets/images/logo/logo.png"/>
          </router-link>
          <!-- /Logo -->
          <!-- Menu Buttons -->
          <div>
            <!-- Close Button -->
            <template v-if="showCloseButton">
              <feather-icon icon="XIcon" class="text-primary m-0 mb-10 cursor-pointer" @click="$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)" />
            </template>
          </div>
          <!-- /Menu Toggle Buttons -->
        </div>
        <!-- /Header -->

        <!-- Header Shadow -->
        <div class="shadow-bottom" v-show="showShadowBottom" />
        
        <!-- AGENCY -->
        <div v-if="$store.getters['dash/agency'].isAgency" :class="{'pl-6' : isValidMulti, 'pl-8': !isValidMulti}" class="mt-2 w-full border-box" >
          <p class="text-sm text-light">CURRENT BRAND</p>
          <div class="pr-10 my-1" v-if="!$store.getters['dash/agency'].isClientName">
            <span class="font-semibold leading-tight  whitespace-normal text-lg">{{ $store.getters['dash/agency'].agencyName }}</span>
          </div>
          <div class="pr-10 my-1" v-else>
            <span class="font-semibold leading-tight whitespace-normal text-lg">{{ $store.getters['dash/agency'].isClientName }}</span>
          </div>
          <div>            
            <a class="block mt-2 text-sm" href="" @click.prevent="toggleShowAgencyAccounts">Agency Settings ></a>
          </div>
          
        </div>
        <vs-divider class="px-5 mb-0" v-if="$store.getters['dash/agency'].isAgency" />
      
        <vs-popup class="holamundo" title="Agency Options" :active.sync="showAgencyAccounts" v-if="$store.getters['dash/agency'].isAgency">          
         
          <vs-collapse type="margin" class="small" v-if="!$store.getters['dash/subscription'].planString"> 
            <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle" class="mb-6">
              <div slot="header" class="font-medium py-2 font-semibold">
                Buy Bulk Agency LTD Codes
              </div>
              <p class="mb-2">For a limited time, we're offering bulk purchase pricing of LTD codes to our agencies.</p>              
              <p>
         
         <vs-table max-items="20" :data="[
          {
            country: '2 - 4',
            cc: '$59',
            dc: '4 codes @ $59 = $236'
          },
          {
            country: '5 - 9',
            cc: '$55',
            dc: '7 codes @ $55 = $385'
          },
          {
            country: '10+',
            cc: '$49',
            dc: '11 codes @ $49 = $539'
          }]" stripe >
            <template slot="thead">
              <vs-th>Number of codes purchased</vs-th>
              <vs-th>Price per code</vs-th>
              <vs-th>Example</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].dateSent">
                  {{ data[indextr].country }}
                </vs-td>
                <vs-td :data="data[indextr].to">
                  {{ data[indextr].cc}}
                </vs-td>
                <vs-td :data="data[indextr].to">
                  {{ data[indextr].dc}}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
              </p>

              <p class="mt-3">Please <a href="" @click.prevent="() => {
                showAgencyAccounts = false
                chatToUs()
              }">reach out</a> for purchase.</p>
              <p class="mt-2">Bulk purchases aren't refundable, please ensure familiarity with the agency offering before purchase.</p>

            </vs-collapse-item>
          </vs-collapse>
         
          <vs-list-header title="Agency Account" class="font-medium text-lg"></vs-list-header>
          <div class="vx-row p-0 m-0 my-8" >
            <div class="vx-col p-0 m-0 w-full md:w-1/2" >
              <span class="font-semibold inline-block">{{ $store.getters['dash/agency'].agencyName }}  <span class="font-light">
                {{ !$store.getters['dash/agency'].isClientName ?  '(Current)' : '' }}
              </span></span>
              <span class="block" v-if="Array.isArray($store.getters['dash/agency'].agencyEntityDocID)">{{$store.getters['dash/agency'].agencyEntityDocID.length}}  Space{{$store.getters['dash/agency'].agencyEntityDocID.length > 1 ? "s":""}}</span>
              <span v-else class="block">1 Space</span>
            </div>
            <div class="vx-col p-0 m-0 w-full md:w-1/2  mt-2 md:mt-0" >
              <div class="inline-block mr-1">
                <vs-button class="lg:w-64" :type="$store.getters['dash/agency'].isClientName ? 'filled' : 'border'" icon-pack="feather" icon="icon-eye" @click="manageAccount('agency')">{{ $store.getters['dash/agency'].isClientName ? 'Switch' : 'Reload' }}</vs-button>
            </div>
            </div>
          </div>
          <vs-list-header icon-pack="feather" icon="icon-users" title="Clients" class="font-medium text-lg"></vs-list-header>
          <div v-if="$store.getters['dash/agency'].agencyBrands.length === 0" class="my-4">
            <p>You don't have any client accounts.</p>
          </div>
          <div v-else class="vx-row p-0 m-0 my-8" v-for="(location,i) in $store.getters['dash/agency'].agencyBrands">
            <div class="vx-col p-0 m-0 w-full md:w-1/2" >
              <span class="font-bold inline-block">{{ location.clientName }} <span class="font-light">
                {{ $store.getters['dash/agency'].isClientName === location.clientName ?  '(Current)' : '' }}
              </span> </span>
              <span class="block" v-if="Array.isArray(location.entityDocID)">{{location.entityDocID.length}}  Space{{location.entityDocID.length > 1 ? "s":""}}</span>
              <span v-else class="block">1 Space</span>
            </div>
            <div class="vx-col p-0 m-0 w-full md:w-1/2 mt-2 md:mt-0" >
              <div class="inline-block mr-1">
                <vs-button class="lg:w-64" :type="$store.getters['dash/agency'].isClientName === location.clientName ? 'border' : 'filled' " icon-pack="feather" icon="icon-eye" @click="manageAccount(location.clientID)"> {{ $store.getters['dash/agency'].isClientName === location.clientName ?  'Reload' : 'Switch' }} </vs-button>
            </div>
              <div class="inline-block" >
                <vs-button icon-pack="feather" icon="icon-trash" type="border" @click="removeAccount({clientID: location.clientID, clientName: location.clientName})"></vs-button>
              </div>
            </div>
          </div>
          <vs-divider/>
          <vs-button class="w-full" @click="addNewClient(true)">Add New Client</vs-button>
          <vs-popup class="holamundo" title="Remove client" :active.sync="showSureRemoveClient" @close="iDontWantToRemoveClient">
            <div class="con-vs-alert mt-3 con-vs-alert-danger">
              <h4 class="titlex vs-alert--title">Warning</h4>
              <div class="vs-alert text-lg">
              If you remove this client, you will lose all data, feedback and accounts associated with it!
            </div>
            </div>
            <vs-divider class="my-4"/>
            <p v-if="clientToRemoveID !== false" class="text-lg mb-2">If you're sure you want to remove the client <span class="font-medium text-xl">{{ clientToRemoveName }}</span>, please type 'remove' in the below textbox.</p>
            <vs-input placeholder="Type 'remove' to continue." v-model="removeText"/>
            <div class="overflow-auto mt-4">
              <vs-button class="float-right ml-1" @click="removeClientCall" :disabled="removeText !== 'remove'">Remove</vs-button>
              <vs-button type="border" class="float-right" @click="iDontWantToRemoveClient">Cancel</vs-button>
            </div>
          </vs-popup>
        </vs-popup>

        <!-- END AGENCY -->






        <!-- Multi location selector -->
        <div class="mt-3" v-if="isValidMulti">
          <p class="text-sm text-light ml-6 mb-2">CURRENT SPACE</p>
          <div class="px-6 relative cursor-pointer" id="location">
            <v-select placeholder="Change Space..." :clearable="false" class="w-full bg-white" :searchable="multiLocations.length > 5" :options="multiLocations" label="businessNameShort" :reduce="location => location.i" v-model="selectedMultiLocation"/>
          </div>

          <vs-popup class="holamundo" :fullscreen="true"  title="Spaces" :active.sync="showChangeLocation">

          </vs-popup>
        </div>

        <!-- Menu Items -->
        <component :is="scrollbarTag" ref="verticalNavMenuPs" class="scroll-area-v-nav-menu" :class="{'mt-6': !$store.state.dash.isMulti}" :settings="settings" @ps-scroll-y="psSectionScroll" @scroll="psSectionScroll" :key="$vs.rtl">

          <template v-for="(item, index) in menuItemsUpdated">

            <!-- Group Header -->
            <span v-if="item.header && !verticalNavMenuItemsMin" class="navigation-header truncate" :key="`header-${index}`">
              {{ selectedMultiLocation.businessNameShort }}
            </span>
            <!-- /Group Header -->

            <template v-else-if="!item.header">

              <!-- Nav-Item -->
              <v-nav-menu-item
                v-if="(!item.submenu && !(item.dC && $store.getters['dash/isCollaborator'])) || (item.dC === 'only' && $store.getters['dash/isCollaborator'])"
                :key="`item-${index}`"
                :index="index"
                :class="{'mt-0': item.i18n === 'Settings', 'nav-panel-item': item.panel}"
                :to="item.slug !== 'external' ? item.url : null"
                :href="item.slug === 'external' ? item.url : null"
                :icon="item.icon" :target="item.target"
                :isDisabled="item.isDisabled"
                :slug="item.slug">
                  <span class="truncate" :class="{'font-bold ptlwide': item.i18n === 'SEE RESULTS' || item.i18n === 'SHOWCASE'}"  v-show="!verticalNavMenuItemsMin">{{ $t(item.i18n) || item.name }}</span>
                  <vs-chip class="ml-auto" :color="item.tagColor" v-if="item.tag && (isMouseEnter || !reduce)">{{ item.tag }}</vs-chip>
              </v-nav-menu-item>


              <!-- Nav-Group -->
              <template v-else>
                
                <v-nav-menu-group
                  v-if="!(item.dC && $store.getters['dash/isCollaborator'])"
                  :key="`group-${index}`"
                  :class="{'nav-panel-item': item.panel}"
                  :openHover="openGroupHover"
                  :group="item"
                  :groupIndex="index"
                  :open="isGroupActive(item)" />
              </template>
              <!-- /Nav-Group -->
            </template>
          </template>
        </component>
        <!-- /Menu Items -->
      </div>
    </vs-sidebar>

    <!-- Swipe Gesture -->
    <div
      v-if="!isVerticalNavMenuActive"
      class="v-nav-menu-swipe-area"
      v-hammer:swipe="onSwipeAreaSwipe" />
    <!-- /Swipe Gesture -->
  </div>
</template>


<script>

/*

Select all locations from menu? (Below v-select)
<a v-if="!$store.getters['dash/isCollaborator']" class="w-full text-light text-sm block mt-2s" href="" @click.prevent="$router.name !== 'settings-locations' ? $router.push('/dash/settings/locations') : () => {}">All Locations<feather-icon icon="ArrowRightIcon" svgClasses="ml-1 w-3 icon-down-xs h-3 text-light"></feather-icon></a>

*/

import vSelect from 'vue-select'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VNavMenuGroup from './VerticalNavMenuGroup.vue'
import VNavMenuItem from './VerticalNavMenuItem.vue'
import changeCurrentLocation from '../../../methods/changeCurrentLocation'

export default {
  name: 'v-nav-menu',
  components: {
    VNavMenuGroup,
    VNavMenuItem,
    VuePerfectScrollbar,
    vSelect
  },
  props: {
    logo:             { type: String },
    openGroupHover:   { type: Boolean, default: false },
    parent:           { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    navMenuItems:     { type: Array,   required: true },
    title:            { type: String }
  },
  data: () => ({

    showAgencyAccounts: false,
    showSureRemoveClient: false,
    clientToRemoveID: false,
    clientToRemoveName: false,
    removeText: '',

    clickNotClose       : false, // disable close navMenu on outside click
    isMouseEnter        : false,
    reduce              : false, // determines if navMenu is reduce - component property
    showCloseButton     : false, // show close button in smaller devices
    locationFilter: '',
    removeText: '',
    showSureRemoveLocation: false,
    currentLocationToRemove: false,
    settings            : {      // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed        : 1,
      swipeEasing       : true
    },
    showShadowBottom    : false
  }),
  computed: {
    isValidMulti () {
      return this.$store.state.dash.isMulti && this.$store.state.dash.allEntitiesLoaded && this.$store.getters['dash/subscription'].plan !== '1m' && this.$store.getters['dash/subscription'].plan !== '1y'
    },
    showChangeLocation: {
      get () {
        return this.$store.state.dash.showChangeLocation
      },
      set (v) {
        this.$store.commit('dash/TOGGLE_SELECT_LOCATION', v)
      }
    },
    selectedMultiLocation: {
      get () {
        return this.$store.state.dash.currentMultiLocationI
      },
      set (v) {
        
        const newEID = this.multiLocations[v].businessID

        const cURL = new URL(window.location.href)

        window.location.href = `${cURL.origin}${cURL.pathname}?e=${newEID}`       

      }
    },
    multiLocations () {
      if (this.$store.state.dash.isMulti && this.$store.state.dash.allEntitiesLoaded) {
        return this.$store.state.dash.multiLocations
      } else {
        return []
      }
    },
    selectedQuestion: {
      get () {
        return this.$store.state.dash.viewState.filters.view.questionID
      },
      set (v) {
        this.$store.commit('dash/SET_QUESTION_FILTER', v)
      }
    },
    isGroupActive () {
      return (item) => {
        const path        = this.$route.fullPath
        const routeParent = this.$route.meta ? this.$route.meta.parent : undefined
        let open          = false

        const func = (item) => {
          if (item.submenu) {
            item.submenu.forEach((item) => {
              if (item.url && (path === item.url || routeParent === item.slug)) { open = true } else if (item.submenu) { func(item) }
            })
          }
        }
        func(item)
        return open
      }
    },
    menuItemsUpdated () {
      const clone = this.navMenuItems.slice()

      for (const [index, item] of this.navMenuItems.entries()) {
        if (item.header && item.items.length && (index || 1)) {
          const i = clone.findIndex(ix => ix.header === item.header)
          for (const [subIndex, subItem] of item.items.entries()) {
            clone.splice(i + 1 + subIndex, 0, subItem)
          }
        }
      }

      return clone
    },
    isVerticalNavMenuActive: {
      get ()    { return this.$store.state.isVerticalNavMenuActive },
      set (val) { this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', val) }
    },
    layoutType () { return this.$store.state.mainLayoutType },
    reduceButton: {
      get ()    { return this.$store.state.reduceButton },
      set (val) { this.$store.commit('TOGGLE_REDUCE_BUTTON', val) }
    },
    isVerticalNavMenuReduced () { return Boolean(this.reduce && this.reduceButton) },
    verticalNavMenuItemsMin ()  { return this.$store.state.verticalNavMenuItemsMin },
    scrollbarTag ()             { return this.$store.getters.scrollbarTag          },
    windowWidth ()              { return this.$store.state.windowWidth             }
  },
  watch: {
    '$route' () {
      if (this.isVerticalNavMenuActive && this.showCloseButton) this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
    },
    reduce (val) {
      const verticalNavMenuWidth = val ? 'reduced' : this.$store.state.windowWidth < 1350 ? 'no-nav-menu' : 'default'
      this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)

      setTimeout(function () {
        window.dispatchEvent(new Event('resize'))
      }, 100)
    },
    layoutType ()   { this.setVerticalNavMenuWidth() },
    reduceButton () { this.setVerticalNavMenuWidth() },
    windowWidth ()  { this.setVerticalNavMenuWidth() }
  },
  methods: {
    iDontWantToRemoveClient() {
      this.showSureRemoveClient = false
      this.clientToRemoveID = false
      this.clientToRemoveName = false
      this.removeText = ''
    },
    addNewClient(toggle) {
      this.$store.commit('signUpState/RESET_SIGNUP_STATE')
      if (toggle) this.toggleShowAgencyAccounts()
      setTimeout(() => {
      this.$router.push('/dash/addclient')
        }, 10)
    },
    manageAccount(id) {
      let cURL = new URL(window.location.href)
      if (id === 'agency') {
        window.location.href = cURL.origin + cURL.pathname
      } else {
        window.location.href = cURL.origin + cURL.pathname + '?client=' + id
      }
    },
    removeClientCall () {
      this.$vs.loading()
      this.$store.dispatch('dash/REMOVE_CLIENT', {
        clientID: this.clientToRemoveID
      }).then((res) => {
        this.$vs.loading.close()
        if (res.data.removed) {
          this.$vs.notify({
            title: 'Remove client',
            text: 'Client has been removed successfully.',
            color: 'success',
            time: 60000,
            iconPack: 'feather',
            icon:'icon-check'})
            let cURL = new URL(window.location.href)
            window.location.href = cURL.origin + '/dash/home'
        } else if (res.data.removed === false) {
          this.$vs.notify({
            title: 'Remove client',
            text: 'This client is currently subscribed to a plan. Please reach out to support (left of your screen) to cancel this client and remove the plan from your agency invoice. You can also mail us at support@feedback.link',
            color: 'primary',
            time: 60000,
            iconPack: 'feather',
            icon:'icon-info'})
            this.iDontWantToRemoveClient()
            this.toggleShowAgencyAccounts()
            this.chatToUs()
        }
      }).catch(() => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Remove client',
          text: 'We encountered a problem trying to remove your client account. Please try again or reach out to support at support@feedback.link.',
          color: 'danger',
          time: 20000,
          iconPack: 'feather',
          icon:'icon-alert-circle'})
      })
    },
    toggleShowAgencyAccounts() {
      this.showAgencyAccounts = !this.showAgencyAccounts
    },
    removeAccount(payload) {
      this.showSureRemoveClient = true
      this.clientToRemoveID = payload.clientID
      this.clientToRemoveName = payload.clientName
    },
    removeLocation(uid) {

      this.$vs.loading()
      this.$store.dispatch('dash/REMOVE_MULTI_LOCATION', {
        locationUID: uid
      }).then((res) => {
        //noconsoleconsole.log(res)
        if (typeof res.data.error !== 'undefined') {
          this.$vs.notify({
            title:'Remove Space',
            time: 10000,
            text:'Oops! Something went wrong, and we couldn\'t remove this space. Please try again, and please notify support if it happens again: support@feedback.link',
            color:'warning',
            iconPack: 'feather',
            icon:'icon-alert-circle'})
        } else {
          this.$vs.notify({
            title:'Remove Space',
            text:'Space removed successfully',
            color:'success',
            time: 8000,
            iconPack: 'feather',
            icon:'icon-check'})
            let url = window.location.href
            let arr = url.split("/");
            window.location.href = arr[0] + '//' + arr[2] + '/dash/home'
        }

        this.$vs.loading.close()

      }).catch(() => {
        this.$vs.notify({
          title:'Remove Space',
          time: 10000,
          text:'Oops! Something went wrong, and we couldn\'t remove this space. Please try again, and please notify support if it happens again: support@feedback.link',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-alert-circle'})
          this.$vs.loading.close()
      })

    },
    iDontWantToRemoveLocation () {
      this.removeText = ''
      this.showSureRemoveLocation = false
      this.currentLocationToRemove = false
    },
    addNewLocation () {

      setTimeout(()=>{
        this.$store.commit('LOAD_ADDNEW_STATE')
        this.$store.commit('signUpState/RESET_SIGNUP_STATE')
        this.$router.push('/dash/addnew')
      }, 1)

      this.$store.commit('dash/TOGGLE_SELECT_LOCATION', false)

    },
    onMenuSwipe (event) {
      if (event.direction === 4 && this.$vs.rtl) {

        // Swipe Right
        if (this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = false

      } else if (event.direction === 2 && !this.$vs.rtl) {

        // Swipe Left
        if (this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = false
      }
    },
    onSwipeAreaSwipe (event) {

      if (event.direction === 4 && !this.$vs.rtl) {

        // Swipe Right
        if (!this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = true
      } else if (event.direction === 2 && this.$vs.rtl) {

        // Swipe Left
        if (!this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = true
      }
    },
    psSectionScroll () {
      const scroll_el = this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs
      this.showShadowBottom = scroll_el.scrollTop > 0
    },
    mouseEnter () {
      if (this.reduce) this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)
      this.isMouseEnter = true
    },
    mouseLeave () {
      if (this.reduce) this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', true)
      this.isMouseEnter = false
    },
    setVerticalNavMenuWidth () {

      if (this.windowWidth > 1350) {
        if (this.layoutType === 'vertical') {

          // Set reduce
          this.reduce = !!this.reduceButton

          // Open NavMenu
          this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin = !!(this.reduceButton && !this.isMouseEnter)
          this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

          // Menu Action buttons
          this.clickNotClose   = true
          this.showCloseButton = false

          const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? 'reduced' : 'default'
          this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)

          return
        }
      }

      // Close NavMenu
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      // Reduce button
      if (this.reduceButton) this.reduce = false

      // Menu Action buttons
      this.showCloseButton = true
      this.clickNotClose   = false

      // Update NavMenu Width
      this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      // Remove Only Icon in Menu
      this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)


      // if(this.layoutType === 'vertical' || (this.layoutType === 'horizontal' && this.windowWidth < 1200))
      // if (this.windowWidth < 1200) {

      //   // Close NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      //   // Reduce button
      //   if (this.reduceButton) this.reduce = false

      //   // Menu Action buttons
      //   this.showCloseButton = true
      //   this.clickNotClose   = false

      //   // Update NavMenu Width
      //   this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      //   // Remove Only Icon in Menu
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)

      // } else {

      //   // Set reduce
      //   this.reduce = this.reduceButton ? true : false

      //   // Open NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

      //   // Set Menu Items Only Icon Mode
      //   const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

      //   // Menu Action buttons
      //   this.clickNotClose   = true
      //   this.showCloseButton = false

      //   const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
      //   this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)
      // }
    }
  },
  mounted () {
    this.setVerticalNavMenuWidth()
  }
}

</script>


<style lang="scss">

@import "@/assets/scss/vuexy/components/verticalNavMenu.scss";

#location .vs__selected {
  font-weight: 600 !important;
}

/* Light-gray panel behind the key journey items (Engage / See Results / Showcase).
   The three are siblings in the render loop, so the "panel" is a shared background:
   first/last detection via sibling selectors keeps it correct when items are
   hidden per-role (e.g. Showcase for collaborators). */
/* .v-nav-menu prefix required: the theme's "padding: 0 15px" on top-level
   items is nested under .v-nav-menu (3-class specificity) — without it our
   padding override loses and the panel content shifts 10px right */
.v-nav-menu .scroll-area-v-nav-menu {
  /* !important needed: tailwind.config.js sets important:true, so the my-1
     baked into VerticalNavMenuItem's root would otherwise win and leave a
     white gap above/below the plain items (Showcase) inside the panel */
  > .nav-panel-item {
    background: rgba(115, 103, 240, 0.08);  /* light tint of theme primary #7367f0 */
    margin: 0 10px !important;              /* inset from sidebar edges */
    padding: 0 5px;                         /* 10+5 = theme's 15px, keeps icons aligned */
  }
  > .nav-panel-item:first-child,
  > :not(.nav-panel-item) + .nav-panel-item {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    margin-top: 0.5rem !important;
    padding-top: 4px;
  }
  /* kept as separate rules: a browser without :has would drop a combined
     selector list entirely, losing the :last-child fallback too */
  > .nav-panel-item:last-child {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    margin-bottom: 0.5rem !important;
    padding-bottom: 4px;
  }
  > .nav-panel-item:has(+ :not(.nav-panel-item)) {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    margin-bottom: 0.5rem !important;
    padding-bottom: 4px;
  }
}

</style>
